import { createRoot } from "react-dom/client";
import { createInertiaApp } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import "dayjs/locale/de";
import "dayjs/locale/uk";
import "dayjs/locale/fr";
import relativeTime from "dayjs/plugin/relativeTime";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { ThemeProvider } from "@/Mixins/useDarkSide";
import AppLayout from "@/components/Layouts/AppLayout";

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

/*import route from "ziggy-js";
import {Ziggy} from "./ziggy";*/
//globalThis.route = (name, params, absolute, config = Ziggy) => route(name, params, absolute, config);
globalThis.ssr = false;
globalThis.localMemory = {};

// Автоматическое обновление при новой версии Service Worker (client-only)
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
    navigator.serviceWorker.addEventListener("controllerchange", () => {
        console.log("[App] Service Worker updated, reloading page...");
        window.location.reload();
    });

    // Слушаем сообщения от Service Worker
    navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data && event.data.type === "SW_UPDATED") {
            console.log("[App] New SW version available:", event.data.version);
            // Перезагружаем страницу автоматически
            window.location.reload();
        }
    });
}

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => {
        const page = resolvePageComponent(
            `./Pages/${name}.tsx`,
            import.meta.glob("./Pages/**/*.tsx")
        );
        page.then((module: any) => {
            if (!module.default) {
                throw new Error(
                    `Page component ${name} does not have a default export`
                );
            }
            if (!module.default.layout) {
                module.default.layout = (page: any) => <AppLayout>{page}</AppLayout>;
            }
        });
        return page;
    },
    setup({ el, App, props }) {
        const root = createRoot(el);
        root.render(
            <ThemeProvider>
                <App {...props} />
            </ThemeProvider>
        );
    },
    progress: {
        delay: 250,
        color: "#6C85F6",
        includeCSS: true,
        showSpinner: false,
    },
}).catch((error) => {
    console.error("Inertia initialization error:", error);
});
